export enum TipType {
    PreOrder = "preOrder",
}
